import { Button, Switch, Tooltip } from "antd";
import type { ColumnsType } from "antd/es/table";
import { InfoCircleOutlined } from '@ant-design/icons';
import { FormConfigType } from "../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../locales";
import { floatNumberInThousands } from "../../utils/tools"
import { CommonServer } from "./../../server";

const server = CommonServer.Level

const lang = langPage?.level;

const renderPrice = (val: number | string) => {
    return floatNumberInThousands(val) || ''
}

export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef, setLoading, refresh } = props;

    return [
        {
            title: lang?.title,
            dataIndex: "Name",
        },
        {
            title: lang?.level,
            dataIndex: "Level",
        },
        // {
        //     title: (
        //         <Tooltip title={lang?.cardNumTip}>
        //             <span>{lang?.cardNum}</span> <InfoCircleOutlined />
        //         </Tooltip>
        //     ),
        //     dataIndex: "CardNum",
        // },
        {
            title: lang?.introduction,
            dataIndex: "Introduction",
        },
        // {
        //     title: lang?.minRechargeAmount,
        //     dataIndex: "MinRechargeAmount",
        // },
        {
            title: lang?.openCardFee,
            dataIndex: "OpenCardFee",
            render: renderPrice
        },
        {
            title: lang?.serviceRate,
            dataIndex: "ServiceRate",
        },
        // {
        //     title: langCommon?.sort,
        //     dataIndex: "Sort",
        // },
        {
            title: langCommon?.status,
            dataIndex: "StatusString",
        },
        // {
        //     title: '账户充值费率',
        //     dataIndex: "UsdtRechargeRate",
        // },
        {
            title: 'ATM提现费率',
            dataIndex: "AtmWithdrawRate",
        },
        // {
        //     title: '实体卡费',
        //     dataIndex: "PhysicalCardFee",
        // },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 80,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link"
                            onClick={() => operationRef?.current?.changeVisible(row, 'modify')}
                        >{langCommon?.modify}</Button>
                    </div>
                )
            }
        }
    ]
}

export const DEFAULT_OPERATION_DATA = {
    // CardNum: null,
    Introduction: null,
    // MinRechargeAmount: null,
    Name: null,
    OpenCardFee: null,
    ServiceRate: null,
    // Sort: 1,
    Status: null,
    Level: null,
    // UsdtRechargeRate: null,
    // WithdrawRate: null,
    // PhysicalCardFee: null
    AtmWithdrawRate: null
}

export const generateOperationFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: lang?.title,
            type: "input",
            field: "Name",
            allowClear: true,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.title}`
            }]
        },
        // {
        //     title: (
        //         <Tooltip title={lang?.cardNumTip}>
        //             <span>{lang?.cardNum}</span> <InfoCircleOutlined />
        //         </Tooltip>
        //     ),
        //     type: "inputNumber",
        //     field: "CardNum",
        //     min: 0,
        //     style: { width: 220 },
        //     suffix: '张',
        //     placeholder: `${langCommon?.pleaseInput}${lang?.cardNum}`,
        //     rules: [{
        //         required: true,
        //         message: `${langCommon?.pleaseInput} ${lang?.cardNum}`
        //     }]
        // },
        // {
        //     title: lang?.minRechargeAmount,
        //     type: "inputNumber",
        //     field: "MinRechargeAmount",
        //     min: 0,
        //     style: { width: 220 },
        //     suffix: '美元',
        //     rules: [{
        //         required: true,
        //         message: `${langCommon?.pleaseInput} ${lang?.minRechargeAmount}`
        //     }]
        // },
        {
            title: lang?.openCardFee,
            type: "inputNumber",
            field: "OpenCardFee",
            min: 0,
            suffix: '美元',
            style: { width: 220 },
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.openCardFee}`
            }]
        },
        {
            title: lang?.serviceRate,
            type: "inputNumber",
            field: "ServiceRate",
            min: 0,
            style: { width: 200 },
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.serviceRate}`
            }]
        },
        {
            title: "等级",
            type: "inputNumber",
            field: "Level",
            min: 1,
            style: { width: 200 },
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput}等级`
            }]
        },
        // {
        //     title: lang?.usdtRechargeRate,
        //     type: "inputNumber",
        //     field: "UsdtRechargeRate",
        //     min: 0,
        //     style: { width: 200 },
        //     rules: [{
        //         required: true,
        //         message: `${langCommon?.pleaseInput} ${lang?.usdtRechargeRate}`
        //     }]
        // },
        // {
        //     title: '账户提现费率',
        //     type: "inputNumber",
        //     field: "WithdrawRate",
        //     min: 0,
        //     style: { width: 200 },
        //     rules: [{
        //         required: true,
        //         message: `${langCommon?.pleaseInput} 账户提现费率`
        //     }]
        // },
        // {
        //     title: '实体卡申请费用',
        //     type: "inputNumber",
        //     field: "PhysicalCardFee",
        //     min: 0,
        //     suffix: '美元',
        //     style: { width: 220 },
        //     rules: [{
        //         required: true,
        //         message: `${langCommon?.pleaseInput} 实体卡申请费用`
        //     }]
        // },
        // {
        //     title: langCommon?.sort,
        //     type: "inputNumber",
        //     field: "Sort",
        //     min: 1,
        //     style: { width: 200 },
        //     rules: [{
        //         required: true,
        //         message: `${langCommon?.pleaseInput} ${langCommon?.sort}`
        //     }]
        // },
        {
            title: "ATM提现费率",
            type: "input",
            field: "AtmWithdrawRate",
            min: 0,
            style: { width: 200 },
            rules: [{
                required: true,
                message: `请输入ATM提现费率`
            }]
        },
        {
            title: langCommon?.status,
            type: "select",
            field: "Status",
            style: { width: 200 },
            options: [
                { id: 1, name: langCommon?.enabled },
                { id: 2, name: langCommon?.disable }
            ],
            rules: [{
                required: true,
                message: `${langCommon?.pleaseSelect} ${langCommon?.status}`
            }]
        },
        {
            title: lang?.introduction,
            type: "input",
            extendType: "TextArea",
            field: "Introduction",
            rows: 5,
            allowClear: true,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.introduction}`
            }]
        },
    ];
}